import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { theme } from '../../../../../shared/theme';
import SpaceCardContent from '../../../../shared/SpaceCardContent';

type Props = {
    reservation: any;
    experience: any;
    onEditReservation?: () => void;
};

export default function ReservationSpacesSection({
    reservation,
    experience,
    onEditReservation,
}: Props) {
    const isMobile = useMediaQuery('(max-width: 770px)');

    return (
        <Box
            component='section'
            aria-labelledby='room-allocation-heading'
            sx={{ mt: 0, borderRadius: 2, overflow: 'hidden' }}
        >
            <Box
                sx={{
                    py: 2.5,
                    backgroundColor: theme.palette.neutral.main,
                }}
            >
                <Typography
                    id='room-allocation-heading'
                    component='h2'
                    variant='body1'
                    sx={{ fontWeight: 700, letterSpacing: 0.2 }}
                >
                    Room allocation
                </Typography>
            </Box>

            <Box
                sx={{
                    pb: isMobile ? 2 : 3,
                    pt: 0,
                    backgroundColor: theme.palette.neutral.main,
                }}
            >
                <Divider sx={{ mt: 0, mb: 2 }} />

                <Grid container spacing={2}>
                    {experience.spaces
                        .filter(
                            (space: any) =>
                                reservation?.spaces?.some(
                                    (s: any) => s.id === space.id,
                                ) || space?.sleepingCapacity > 0,
                        )
                        .map((space: any) => {
                            const attendees =
                                reservation?.spaces?.find(
                                    (s: any) => s.id === space.id,
                                )?.attendees ?? [];
                            return (
                                <Grid item xs={12} md={6} key={space.id}>
                                    <SpaceCardContent
                                        isReservationForm={false}
                                        isExperienceForm={false}
                                        space={space}
                                        experienceType={experience.type}
                                        assignedAttendeesCount={
                                            attendees?.length
                                        }
                                        shouldShowSelected={false}
                                        attendees={attendees}
                                        onEditReservation={onEditReservation}
                                    />
                                </Grid>
                            );
                        })}
                </Grid>
            </Box>
        </Box>
    );
}
